import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_esfhqeqhi5: FaireBrandEntity = {
  token: "b_esfhqeqhi5",
  type: "brand",
  name: "Gourmet Warehouse Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/f39edfca7641b14ca217defaad009fee636a790c305d7073b4e34be05f596187.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4760aa5dd3db462ad99563723947f7ec51d1322dafe2e5c90bae49244589e1d9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f39edfca7641b14ca217defaad009fee636a790c305d7073b4e34be05f596187.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4760aa5dd3db462ad99563723947f7ec51d1322dafe2e5c90bae49244589e1d9.png",
  location: "Hilton Head Island, SC, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 111,
  isTopShop: true,
  isInsider: true,
  description:
    "About Gourmet Warehouse \nDrawing inspiration from the picturesque beauty of Hilton Head Island, nestled in the heart of South Carolina's enchanting Lowcountry, Gourmet Warehouse boasts a legacy of 30 years, passionately handcrafting exceptional gourmet products. Our commitment to quality is showcased in each small batch, where meticulous attention and care are poured into every container, delivering a culinary experience that transcends the ordinary. Gourmet Warehouse produces high quality products under the brand names The Flavors of Ernest Hemingway, Southern Living and their legacy brand, Gourmet Warehouse. \n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.982Z",
    importedBy: "entity-db-cli",
  },
};
